import {Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import * as d3 from 'd3';
import * as _ from 'lodash';

import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-dashboard-report-trend-bar',
  templateUrl: './dashboard-report-trend-bar.component.html',
  styleUrls: ['./dashboard-report-trend-bar.component.css']
})
export class DashboardReportTrendBarComponent implements OnInit {
  @ViewChild('trendBarChart')
  private trendBarChartContainer: ElementRef;

  @ViewChild('reportBody')
  private reportBody: ElementRef;

  respObject: any;
  private clientId: number;
  private notifier: NotifierService;

  reportTypeArray = [];
  reportFilterArray = [];
  reportTypeValueArray = [];
  
  ticketTypeArray = [];

  selectedReportType : number; 
  selectedReportFilter : number; 
  selectedReportTypeValue: number;

  selectedTicketType: number;

  reportTypeTitle: string;
  reportFilterTitle: string;
  reportTypeValueTitle: string;
  trendBarReportTitle : string;

  trendChartTitle: boolean; 
  viewReportTypeValue : boolean;
  viewReport: boolean;
  dataLoaded: boolean;
  reportTrendBarData = [];

  viewTicketType : boolean;

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
    private modalService: NgbModal, notifier: NotifierService) {
      this.notifier = notifier;
  }

  ngOnInit() {
    
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
         //this.getSLAComplainceReport();
         //this.getTicketType();
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });

    this.reportTypeArray = [{type:0, view:"Select Report Type"},
                            {type:1, view:"Overall"},
                            {type:2, view:"Support group"},
                            {type:3, view:"Category"},
                            {type:4, view:"Ticket type"},
                          ];

    this.reportFilterArray = [{type:0, view:"Select Report Filter"},
                            {type:1, view:"Day wise - Current Month"},
                            {type:2, view:"Week wise - Current Month"},
                            {type:3, view:"Month wise - Last Three Months"},
                            {type:4, view:"Quarter wise - Last Four Quarters"},
                            {type:5, view:"Yearly - Last Five Years"}
                        ];

    const Data = [
      { Date: "2016-06-14",
        Categories: [{ Name: "Category1", Value: 368 }, { Name: "Category2", Value: 321 }, { Name: "Category3", Value: 524 }, { Name: "Category4", Value: 24 }],
        LineCategory: [{ Name: "SLA Complaince", Value: 69 }] },

      { Date: "2016-06-15",
      Categories: [{ Name: "Category1", Value: 521 }, { Name: "Category2", Value: 123 }, { Name: "Category3", Value: 653 }, { Name: "Category4", Value: 24 }],
      LineCategory: [{ Name: "SLA Complaince", Value: 89 }] },
      
      { Date: "2016-06-17",
      Categories: [{ Name: "Category1", Value: 368 }, { Name: "Category2", Value: 236 }, { Name: "Category3", Value: 537 }, { Name: "Category4", Value: 24 }],
      LineCategory: [{ Name: "SLA Complaince", Value: 63 }] },
      
      { Date: "2016-06-18",
      Categories: [{ Name: "Category1", Value: 423 }, { Name: "Category2", Value: 330 }, { Name: "Category3", Value: 689 }, { Name: "Category4", Value: 24 }],
      LineCategory: [{ Name: "SLA Complaince", Value: 86 }] },
      
      { Date: "2016-06-19",
      Categories: [{ Name: "Category1", Value: 601 }, { Name: "Category2", Value: 423 }, { Name: "Category3", Value: 490 }, { Name: "Category4", Value: 24 }],
      LineCategory: [{ Name: "SLA Complaince", Value: 65 }] },
      
      { Date: "2016-06-20",
      Categories: [{ Name: "Category1", Value: 412 }, { Name: "Category2", Value: 461 }, { Name: "Category3", Value: 321 }, { Name: "Category4", Value: 24 }],
      LineCategory: [{ Name: "SLA Complaince", Value: 75 }] }
      ]

    this.selectedReportFilter = 0;
    this.selectedReportType = 0;
    this.selectedReportTypeValue = 0;
    this.viewReport = false;
    this.dataLoaded = true;
    this.reportFilterTitle = "";
    this.viewReportTypeValue = false;
    this.viewTicketType = false;
    this.selectedTicketType = 0;

    //this.viewReport = true;
    //this.createTrendBarChart(Data);
    
  }

  onReportTypeChange(value: any){
    this.selectedReportTypeValue = 0;
    this.viewTicketType = false;
    this.viewReportTypeValue = false;
    if(this.selectedReportType === 4 || this.selectedReportType.toString() === "4"){
      this.getTicketType();
      this.viewReportTypeValue = true;
    }else if(this.selectedReportType === 2 || this.selectedReportType.toString() === "2"){
      this.getTeamType();
      this.viewReportTypeValue = true;
    }else if(this.selectedReportType === 3 || this.selectedReportType.toString() === "3"){
      this.getTicketTypeForCat();
      this.viewTicketType = true;
    }
  }

  onReportFilterChange(value: any){
    
  }

  onReportTypeValueChange(value: any){
    this.selectedReportFilter = 0;
  }

  getTicketType(){
    this._rest.getTicketType(this.clientId).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
          this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
          this.reportTypeValueArray = this.respObject.details;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  getTicketTypeForCat(){
    this._rest.getTicketType(this.clientId).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
          this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
          this.ticketTypeArray = this.respObject.details;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });

  }

  onChangeTicketType(value: any){
    this.selectedReportTypeValue = 0;
    console.log("onChangeTicketType");
    console.log(value);
    if(value > 0){
      this.viewReportTypeValue = true;
      this.getReportCategory();
    }
    else{
      this.viewReportTypeValue = false;
    }
  }

  getTeamType(){
    this._rest.getProductivityTeam(this.clientId).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
          this.respObject.details.unshift({id: 0, name: 'Select Ticket Support Group'});
          this.reportTypeValueArray = this.respObject.details;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  getReportCategory(){
    this._rest.getReportCategory(this.clientId, this.selectedTicketType).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
          this.respObject.details.unshift({id: 0, name: 'Select Ticket Category'});
          this.reportTypeValueArray = this.respObject.details;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  getReportTypeValue(){

  }

  

  generateDashboardReport(){
    
    if(this.selectedReportType === 0){
      this.notifier.notify('error', "Please select a type");
      return;
    }

    if(this.selectedReportFilter === 0){
      this.notifier.notify('error', "Please select a filter");
      return;
    }

    if(this.selectedReportType === 4 || this.selectedReportType.toString() === "2"){
      
      if(this.selectedReportTypeValue === 0){
        this.notifier.notify('error', "Please select a Support Group");
        return;
      }
    }

    if(this.selectedReportType === 4 || this.selectedReportType.toString() === "3"){
      
      if(this.selectedReportTypeValue === 0){
        this.notifier.notify('error', "Please select a Category");
        return;
      }
    }

    if(this.selectedReportType === 4 || this.selectedReportType.toString() === "4"){
      
      if(this.selectedReportTypeValue === 0){
        this.notifier.notify('error', "Please select a Ticket Type");
        return;
      }
    }

    
    this.viewReport = false;
    this.dataLoaded = false;

    this._rest.getTrendBarReport(this.clientId, this.selectedReportType,this.selectedReportTypeValue,  this.selectedReportFilter).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
          this.dataLoaded = true;
          this.viewReport = true;
          this.reportTypeTitle = this.reportTypeArray[this.selectedReportType].view;
          this.trendBarReportTitle = this.reportFilterArray[this.selectedReportFilter].view + " Trend - "+"Logged Vs Resolved vs SLA Compliance %";
          this.reportTrendBarData = this.respObject.details;
          this.createTrendBarChart(this.reportTrendBarData);      
      } else {
          this.viewReport = false;
          this.dataLoaded = true;
          this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
        this.viewReport = false;
        this.dataLoaded = true;
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  

  createTrendBarChart(Data){
      const element = this.trendBarChartContainer.nativeElement;
      let dwidth = element.parentElement.parentElement.offsetWidth - 60;
      const margin = { top: 20, right: 30, bottom: 60, left: 40 },
      width = dwidth - margin.left - margin.right,
      height = 400 - margin.top - margin.bottom;
      let textWidthHolder = 0;
      /// Adding Date in LineCategory
      Data.forEach(function (d) {
          d.LineCategory.forEach(function (b) {
              b.Date = d.Date;
          })
      });

      var Categories = new Array();
      // Extension method declaration
      //Categories.pro
      //let Data;
      let ageNames;
      const x0 = d3.scaleBand()
                    .rangeRound([0, width])
                    .padding(0.1)
      const XLine = d3.scaleBand()
                      .rangeRound([0, width])
                      .padding(0.1);
      const x1 = d3.scaleBand();

      const y = d3.scaleLinear()
                  .range([height, 0]);

      const YLine = d3.scaleLinear().rangeRound([height, 0])
                      .domain([0, d3.max(Data, function (d) { return d3.max(d.LineCategory, function (b) { return b.Value }) })]);

      const color = d3.scaleOrdinal()
        .range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"]);

      const line = d3.line().x(function (d) {
                        return x0(d.Date) + x0.bandwidth() / 2;
                    }).y(function (d) { return YLine(d.Value) });

      const xAxis = d3.axisBottom()
                      .scale(x0);

      const yAxis = d3.axisLeft()
                      .scale(y)
                      .tickFormat(d3.format(".2s"));

      const YLeftAxis = d3.axisRight()
                          .scale(YLine)
                          .tickFormat(d3.format(".2s"));
      
      d3.select(element).select('svg').remove();

      const svg = d3.select(element).append("svg")
          .attr("width", width + margin.left + margin.right)
          .attr("height", height + margin.top + margin.bottom)
        .append("g")
          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      // Bar Data categories
      Data.forEach(function (d) {
          d.Categories.forEach(function (b) {
              if (Categories.findIndex(function (c) { return c.Name===b.Name}) == -1) {
                  b.Type = "bar";
                  console.log(JSON.stringify(b))
                  Categories.push(b)
              }
          })
      });

      // Line Data categories
      Data.forEach(function (d) {
          d.LineCategory.forEach(function (b) {
              if (Categories.findIndex(function (c) { return c.Name === b.Name }) == -1) {
                  b.Type = "line";
                  console.log(JSON.stringify(b))
                  Categories.push(b)
              }
          })
      });

      // Processing Line data
      let lineData = this.DataSegregator(Data.map(function (d) { return d.LineCategory }), "Name");

      // Line Coloring
      const LineColor = d3.scaleOrdinal();
      LineColor.domain(Categories.filter(function (d) { return d.Type == "line" }).map(function (d) { return d.Name }));
        LineColor.range(["#d40606", "#06bf00", "#98bdc5", "#671919", "#0b172b"])
        x0.domain(Data.map(function (d) { return d.Date; }));
        XLine.domain(Data.map(function (d) { return d.Date; }));
        x1.domain(Categories.filter(function (d) { return d.Type == "bar" }).map(function (d) { return d.Name})).rangeRound([0, x0.bandwidth()]);
        y.domain([0, d3.max(Data, function (d) { return d3.max(d.Categories, function (d) { return d.Value; }); })]);

      svg.append("g")
          .attr("class", "x axis")
          .attr("transform", "translate(0," + height + ")")
          .call(xAxis);

      svg.append("g")
        .attr("class", "y axis")
          .attr("transform", "translate(" + (width) + ",0)")
        .call(YLeftAxis)

      .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", -10)
        .attr("dy", ".71em")
        .attr("fill", "#000000")
        .style("text-anchor", "end")
        .text("Percentage");

      svg.append("g")
          .attr("class", "y axis")
          .call(yAxis)
        .append("text")
          .attr("transform", "rotate(-90)")
          .attr("y", 6)
          .attr("dy", ".71em")
          .attr("fill", "#000000")
          .style("text-anchor", "end")
          .text("Volume");


      const state = svg.selectAll(".state")
          .data(Data)
        .enter().append("g")
          .attr("class", "state")
          .attr("transform", function (d) { return "translate(" + x0(d.Date) + ",0)"; });

      state.selectAll("rect")
          .data(function (d) { return d.Categories; })
          .enter().append("rect")
          .attr("width", x1.bandwidth())
          .attr("x", function (d) { return x1(d.Name); })
          .attr("y", function (d) { return y(d.Value); })
          .attr("height", function (d) { console.log(height); console.log(d.Value); return height - y(d.Value); })
          .style("fill", function (d) { return color(d.Name); });

      // drawaing lines
      svg.selectAll(".lines").data(lineData).enter().append("g").attr("class", "line")
      .each(function (d) {
          let Name=d[0].Name
          d3.select(this).append("path").attr("d", function (b) { return line(b) }).attr("style", "stroke-width: 2px; fill: none; stroke: "+LineColor(Name) );
      })

      // Legends

      var LegendHolder = svg.append("g").attr("class", "legendHolder");
      var legend = LegendHolder.selectAll(".legend")
          .data(Categories.map(function (d) { return {"Name":d.Name,"Type":d.Type}}))
        .enter().append("g")
          .attr("class", "legend")
          .attr("transform", function (d, i) { return "translate(0," +( height+ margin.bottom/2 )+ ")"; })
          .each(function (d,i) {
              //  Legend Symbols

              d3.select(this).append("rect")
              .attr("width", function () { return 18 })
              .attr("x", function (b) {

                  let left = (i+1) * 15 + i * 18 + i * 5 + textWidthHolder;
                  return left;
              })
              .attr("y", function (b) { return b.Type == 'bar'?0:7})
              .attr("height", function (b) { return b.Type== 'bar'? 18:5 })
              .style("fill", function (b) { return b.Type == 'bar' ? color(d.Name) : LineColor(d.Name) });

              //  Legend Text

              d3.select(this).append("text")
              .attr("x", function (b) {

                  let left = (i+1) * 15 + (i+1) * 18 + (i + 1) * 5 + textWidthHolder;

                  return left;
              })
              .attr("y", 9)
              .attr("dy", ".35em")
              .style("text-anchor", "start")
              .text(d.Name);
              //const getWidth = this.legendTextWidth(d.Name, "10px", "calibri")
              const c = document.createElement("canvas");
              const ctx = c.getContext("2d");
              ctx.font = "10px" + ' ' + "calibri";
              const getWidth = ctx.measureText(d.Name).width;

              textWidthHolder += 100;

          });


      // Legend Placing

      d3.select(".legendHolder").attr("transform", function (d) {
          let thisWidth = d3.select(this).node().getBBox().width;
          return "translate(" + ((width) / 2 - thisWidth / 2) + ",0)";
      })
  }

  //  legendTextWidth(text, fontSize, fontName) {
  //     const c = document.createElement("canvas");
  //     const ctx = c.getContext("2d");
  //     ctx.font = fontSize + ' ' + fontName;
  //     return ctx.measureText(text).width;
  // };
    
  DataSegregator(array, on) {
      let SegData;
      let OrdinalPositionHolder = {
          valueOf: function () {
              const thisObject = this;
              const keys = Object.keys(thisObject);
              keys.splice(keys.indexOf("valueOf"), 1);
              keys.splice(keys.indexOf("keys"), 1);
              return keys.length == 0 ? -1 : d3.max(keys, function (d) { return thisObject[d] })
          }
          , keys: function () {
              const thisObject = this;
              const keys = Object.keys(thisObject);
              keys.splice(keys.indexOf("valueOf"), 1);
              keys.splice(keys.indexOf("keys"), 1);
              return keys;
          }
      }
      array[0].map(function (d) { return d[on] }).forEach(function (b) {
          let value = OrdinalPositionHolder.valueOf();
          OrdinalPositionHolder[b] = OrdinalPositionHolder[b]  > -1 ? ++value : 0;
      })

      SegData = OrdinalPositionHolder.keys().map(function () {
          return [];
      });

      array.forEach(function (d) {
          d.forEach(function (b) {
              SegData[OrdinalPositionHolder[b[on]]].push(b);
          })
      });

      return SegData;
  }

  exportAsPDF(){
    this.dataLoaded = false;
    const elementReport = this.reportBody.nativeElement;
    let reportTitle = "Trend Report - ";

    let fileName = this.trendBarReportTitle + ".pdf";
    
  
    html2canvas(elementReport, {
        scale: 2
      }).then(canvas => {  
      const imgWidth = 208;   
      const pageHeight = 295;    
      const imgHeight = canvas.height * imgWidth / canvas.width;  
      const heightLeft = imgHeight; 
      
      const contentDataURL = canvas.toDataURL('image/png')  
      let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF  
      pdf.setFont("helvetica");
      pdf.setFontType("bold");
      pdf.setFontSize(9);
      //pdf.text(reportTitle, 10, 10)  
      pdf.addImage(contentDataURL, 'PNG', 0, 20, imgWidth, imgHeight)  
      pdf.save(fileName); // Generated PDF  
      this.dataLoaded = true;  
    }); 
    

  }

  onResize(e) {
    this.createTrendBarChart(this.reportTrendBarData);
  }


}
